module.exports = __webpack_public_path__ + "ve.svg?05045bcea6cd452ff2110d8595ca1895";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ve.svg
// module id = 1684
// module chunks = 0